module.exports = __webpack_public_path__ + "img/switch-role-bg-guang.5c7a4ba5.png";